import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledNotice, StyledNoticeList } from './styles';
import { OutlineInputControl } from '__components/Inputs/InputControl';
import { useSelector } from 'react-redux';
import { getBusinessTimeZone } from 'store/authentication/selectors';

export const Occurrences: FC<{
  occurrences: Date[];
}> = ({ occurrences = [] }) => {
  const { t, i18n } = useTranslation();
  const businessTimezone = useSelector(getBusinessTimeZone);

  return (
    <OutlineInputControl label={t('Upcoming Triggers (preview)')}>
      <StyledNotice>
        <StyledNoticeList>
          {occurrences.length ? (
            occurrences.map((occurrence, index) => (
              <li key={index}>
                {t('{{date}} at {{time}}', {
                  date: occurrence.toLocaleString(i18n.language, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: businessTimezone,
                  }),
                  time: occurrence.toLocaleTimeString(i18n.language, {
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: businessTimezone,
                  }),
                })}{' '}
                ({businessTimezone})
              </li>
            ))
          ) : (
            <li>No occurrences</li>
          )}
        </StyledNoticeList>
      </StyledNotice>
    </OutlineInputControl>
  );
};
